import { useNode } from "@craftjs/core";
import { cx } from "class-variance-authority";
import * as React from "react";
import { useTranslation } from "react-i18next";
import type { Vendor } from "src/types";

import SettingsTitleWrapper from "@/components/editor/shared/settings-title-wrapper";

import expoTooltipPreview from "./expo-tooltip-preview.jpg";

export default function BoothCardSettings() {
  const { props } = useNode((node) => ({ props: node.data.props }));
  const { name, background_image, image_url, headline }: Vendor = props.vendor;
  const { t } = useTranslation();

  return (
    <SettingsTitleWrapper
      title={t("preference-panel.expo.expo")}
      tooltip={{
        description: `${t("preference-panel.expo.navigate-to-expo")}`,
        image: expoTooltipPreview,
      }}
    >
      {background_image && (
        <Field
          fullSize
          text={name}
          image={background_image}
          label={t("preference-panel.expo.booth-cover")}
        />
      )}
      {image_url && (
        <Field
          text={name}
          image={image_url}
          label={t("preference-panel.expo.booth-logo")}
        />
      )}
      {name && (
        <Field text={name} label={t("preference-panel.expo.booth-name")} />
      )}
      {headline && <Field text={headline} label={t("common.headline")} />}
    </SettingsTitleWrapper>
  );
}

type FieldProps = {
  label: string;
  text: string;
  image?: string;
  fullSize?: boolean;
};

const Field = ({ image, label, text, fullSize }: FieldProps) => (
  <div className="mt-4">
    <p className="mb-3 text-xs font-medium text-gray-700">{label}</p>
    {image && (
      <img
        src={image}
        alt={text}
        className={cx("object-cover, rounded block", {
          "w-full": fullSize,
          "w-[6.25rem]": !fullSize,
        })}
      />
    )}
    {!image && text && (
      <p className="pb-3 text-sm font-medium leading-6 text-gray-800">{text}</p>
    )}
  </div>
);
